@if (pageData() && pageData().projects && pageData().viewletType) {
  @switch (pageData().viewletType) {

    @case (E_VIEWLET_TYPE.GlobalMain) {
      <mat-tab-group dynamicHeight>
        @for (proj of TABS_SETTINGS[E_VIEWLET_TYPE.GlobalMain]; track proj.id) {
          @if (pageData().projects[proj.id] && pageData().projects[proj.id]?.length) {
            <mat-tab [label]="proj.title | translate">
              <app-viewlet-tab
                [viewletType]="E_VIEWLET_TYPE.GlobalMain"
                [projects]="pageData().projects[proj.id]">
              </app-viewlet-tab>
            </mat-tab>
          }
        }
      </mat-tab-group>
    }
    @case (E_VIEWLET_TYPE.GlobalSubPagesType1) {
      @if (pageData().projects) {
        <app-viewlet-tab
          [viewletType]="E_VIEWLET_TYPE.GlobalSubPagesType1"
          [allProjects]="pageData().projects">
        </app-viewlet-tab>
      }
    }
    @case (E_VIEWLET_TYPE.GlobalSubPagesType2) {
      @if (pageData().projects) {
        <app-viewlet-tab
          [viewletType]="E_VIEWLET_TYPE.GlobalSubPagesType2"
          [allProjects]="pageData().projects">
        </app-viewlet-tab>
      }
    }
    @case (E_VIEWLET_TYPE.UKMain) {
      <mat-tab-group dynamicHeight>
        @for (proj of TABS_SETTINGS[E_VIEWLET_TYPE.UKMain]; track proj.id) {
          @if (pageData().projects[proj.id] && (pageData().projects[proj.id] | filterByProjStatus:proj.id)?.length) {
            <mat-tab [label]="proj.title | translate">
              <app-viewlet-tab
                [viewletType]="E_VIEWLET_TYPE.UKMain"
                [projects]="pageData().projects[proj.id] | filterByProjStatus:proj.id">
              </app-viewlet-tab>
            </mat-tab>
          }
        }
      </mat-tab-group>
    }
    @case (E_VIEWLET_TYPE.Canada) {
      @if (pageData().projects) {
        <app-viewlet-tab
          [viewletType]="E_VIEWLET_TYPE.Canada"
          [allProjects]="pageData().projects">
        </app-viewlet-tab>
      }
    }

  }
}
